// extracted by mini-css-extract-plugin
module.exports = {"paymentButton":"_3DjFo14ch-5ITYWcfMVnu_"};